import { ModelBase } from "Core/Models";
import { action, observable } from "mobx";

export class ReservationType1PurchaserModel extends ModelBase<ReservationType1PurchaserModel, ReservationType1PurchaserDTO> {
    //#region Properties
    @observable
    public id: string | undefined = "";

    @observable
    public reservationId: string = "";

    @observable
    public contactId: string = "";

    @observable
    public purchaserPosition: string = "";
    //#endregion Properties

    @action
    public fromDto = (reservationDto: ReservationType1PurchaserDTO) => {
        this.id = reservationDto.id;
        this.reservationId = reservationDto.reservationId;
        this.purchaserPosition = reservationDto.purchaserPosition;
    };

    public toDto = (): ReservationType1PurchaserDTO => {
        return {
            id: this.id,
            reservationId: this.reservationId,
            purchaserPosition: this.purchaserPosition,
        };
    };
}

export interface ReservationType1PurchaserDTO {
    id: string | undefined;
    reservationId: string;
    purchaserPosition: string;
}
